/**
 * Get one element from a set.
 */
const getOneFromSet = <T>(set: Set<T>): T | undefined => {
	return set.values().next().value;
};

export default getOneFromSet;
